import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 10v11l-5 -3l-5 3v-11a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3","key":"svg-0"}],["path",{"d":"M11 3h5a3 3 0 0 1 3 3v11","key":"svg-1"}]]

/**
 * IconBookmarks
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm9va21hcmtzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSAxMHYxMWwtNSAtM2wtNSAzdi0xMWEzIDMgMCAwIDEgMyAtM2g0YTMgMyAwIDAgMSAzIDMiIC8+CiAgPHBhdGggZD0iTTExIDNoNWEzIDMgMCAwIDEgMyAzdjExIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/bookmarks
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBookmarks = createReactComponent('outline', 'bookmarks', 'Bookmarks', __iconNode);

export default IconBookmarks;